import React, { useMemo } from "react";

const clamp01 = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  return Math.min(100, Math.max(0, num));
};

export default function SessionUsageRing({
  percent,
  size = 34,
  strokeWidth = 4,
  variant = "ok", // ok | warn | danger | muted
  title = "",
  showLabel = true,
}) {
  const normalizedPercent = clamp01(percent);

  const { radius, circumference, offset } = useMemo(() => {
    const r = Math.max(2, (Number(size) - Number(strokeWidth)) / 2);
    const c = 2 * Math.PI * r;
    const o = c - (normalizedPercent / 100) * c;
    return { radius: r, circumference: c, offset: o };
  }, [normalizedPercent, size, strokeWidth]);

  const color = useMemo(() => {
    if (variant === "danger") return "var(--session-usage-danger, #ef4444)";
    if (variant === "warn") return "var(--session-usage-warn, #f59e0b)";
    if (variant === "muted") return "var(--session-usage-muted, #94a3b8)";
    return "var(--session-usage-ok, var(--primary-color, #2563eb))";
  }, [variant]);

  return (
    <div
      className="session-usage-indicator"
      style={{ width: size, height: size }}
      title={title || undefined}
      aria-label={title || "Session usage"}
      role="img"
    >
      <svg
        className="session-usage-indicator__svg"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
      >
        <circle
          className="session-usage-indicator__track"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <circle
          className="session-usage-indicator__progress"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          stroke={color}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      {showLabel ? (
        <div className="session-usage-indicator__label">
          {Math.round(normalizedPercent)}%
        </div>
      ) : null}
    </div>
  );
}

